import { NATIVE_ASSET_MOCK_ADDRESS } from '@/config/consts'
import { Address } from 'viem'

export function shortenAddress(address: Address): string {
  return `${address.slice(0, 6)}...${address.slice(-4)}`
}

export function mockNativeToWHYPEOverride(address: Address): Address {
  return address === NATIVE_ASSET_MOCK_ADDRESS ? '0x5555555555555555555555555555555555555555' : address
}
